const taskNotEmpty = (task, taskArray) =>
  ((task === undefined || task === "") && taskArray.length === 0) ||
  (task !== undefined && task !== "");

export default taskNotEmpty;
